const InputError = ({ error, ...rest }) => {
  return (
    <p className="text-yellow-500 pl-2 text-xs">{error ?? rest.children}</p>
  );
};

export default InputError;
